var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCcMastercardGiant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 40,
    viewBox: "0 0 59 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57.3333,
    height: 39,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.583 28.5948C27.5971 30.3086 25.0209 31.3432 22.206 31.3432C15.9249 31.3432 10.833 26.1923 10.833 19.8382C10.833 13.4842 15.9249 8.33325 22.206 8.33325C25.0209 8.33325 27.5971 9.36784 29.583 11.0816C31.569 9.36784 34.1451 8.33325 36.9601 8.33325C43.2412 8.33325 48.333 13.4842 48.333 19.8382C48.333 26.1923 43.2412 31.3432 36.9601 31.3432C34.1451 31.3432 31.569 30.3086 29.583 28.5948Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.583 28.5948C32.0283 26.4846 33.5789 23.3446 33.5789 19.8382C33.5789 16.3319 32.0283 13.1919 29.583 11.0816C31.569 9.36784 34.1451 8.33325 36.9601 8.33325C43.2412 8.33325 48.333 13.4842 48.333 19.8382C48.333 26.1923 43.2412 31.3432 36.9601 31.3432C34.1451 31.3432 31.569 30.3086 29.583 28.5948Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5828 11.0818C32.0281 13.192 33.5786 16.332 33.5786 19.8384C33.5786 23.3447 32.0281 26.4847 29.5828 28.5949C27.1375 26.4847 25.5869 23.3447 25.5869 19.8383C25.5869 16.332 27.1375 13.192 29.5828 11.0818Z",
    fill: "#FF5E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcMastercardGiant);
export default __webpack_public_path__ + "static/media/cc_mastercard_giant.3b172ffdcc40bf6d14e4cb25b5edfb8d.svg";
export { ForwardRef as ReactComponent };